import { tFunctionType, useI18n } from 'app/components/localization';
import { BlockNavigation } from 'app/components/router/Prompt';
import { CallStage, useCallStateContext } from 'app/containers/call/CallStateContext';
import { useBookingState } from 'app/containers/rtc/BookingContext/BookingState';
import { BookingState, BookingTypeSettings } from 'app/models/rtc/booking/constants';
import { getLeaveCallWarningMessage } from 'app/models/rtc/booking/warning';
import { NavigationBlockerType } from 'app/services/history';
import React, { Fragment, FunctionComponent, memo, ReactNode, useCallback } from 'react';

interface IDeps {
  bookingState?: BookingState;
  callStage: CallStage;
  children: ReactNode;
  t: tFunctionType;
}

export const CallDropWarning = memo<IDeps>(({ callStage, children, bookingState, t }) => {
  // Only block if a booking is present and it is set to block offsite navigation.
  const blockNavigation = bookingState && BookingTypeSettings[bookingState.bookingType].blockOffsiteNavigation;

  const unloadWarning: NavigationBlockerType = useCallback(
    ({ isOffsite }) => {
      return isOffsite && bookingState && callStage !== CallStage.PostLocked
        ? getLeaveCallWarningMessage(t, bookingState.bookingType)
        : false;
    },
    [bookingState, callStage, t],
  );

  return (
    <Fragment>
      {children}
      {blockNavigation && <BlockNavigation blocker={unloadWarning} />}
    </Fragment>
  );
});

const CallDropWarningInjectDependencies: FunctionComponent = ({ children }) => {
  const { t } = useI18n();
  const bookingState = useBookingState();
  const { stage } = useCallStateContext();

  return <CallDropWarning children={children} bookingState={bookingState} callStage={stage} t={t} />;
};

export default CallDropWarningInjectDependencies;
